import { render, staticRenderFns } from "./UnpaidInvoiceBanner.vue?vue&type=template&id=1ea68d79&"
import script from "./UnpaidInvoiceBanner.vue?vue&type=script&lang=js&"
export * from "./UnpaidInvoiceBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports